import React from 'react';

import * as css from './index.module.css';

function Link({ url, title, button, className }) {
    return <a href={url} dangerouslySetInnerHTML={{ __html : title }} className={button ? css.button : className }/>;
}

function SubSubNav({ nav, data }) {
    return <ul className={ css.subSubNav }>
        {nav.map(({ id }) =>
            <li key={id}>
                <Link url={data[id].url} title={ data[id].title }/>
            </li>
        )}
    </ul>;
}


function SubNav({ nav, data }) {
    return <ul className={ css.subNav }>
        {nav.map(({ id, children }) =>
            <li key={id}>
                <Link url={data[id].url} title={data[id].title} className={children ? css.children : ''}/>

                {children ? <SubSubNav nav={ children } data={ data } /> : null}
            </li>
        )}
    </ul>;
}

export default function Nav({ nav }) {
    return <nav className={ css.nav }>
        <ul className={css.top}>
            {nav.format.map(({ id, children }, idx) =>
                <li key={id}>
                    <Link url={nav.data[id].url} title={nav.data[id].title} button={idx === nav.format.length - 1}/>

                    {children ? <SubNav nav={ children } data={ nav.data }/> : null}
                </li>
            )}
        </ul>
    </nav>;
}
